/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 *
 */
import axios from 'axios';
import Request from './urlService';
import { handleTracingCookie } from '../utils/cookieHelpers';
let config = require('../config/' + process.env.NODE_ENV);
const DEFAULT_FETCH_TIMEOUT = config.defaultFetchTimeout;

const defaults = {
  baseURL: [config.domain, config.mtfs.root, config.apiversion].join(''),
  timeout: DEFAULT_FETCH_TIMEOUT,
  headers: {
    crfclient: 'true'
  },
  withCredentials: true
};

const authInstance = axios.create(defaults);

authInstance.interceptors.request.use(function (config) {
  handleTracingCookie();
  return config;
});

authInstance.interceptors.response.use(function (response) {
  if (response.headers.location) {
    window.location.replace(response.headers.location);
    return false;
  }
  return response;
});

class AuthService {
  static getClientConfiguration() {
    return authInstance.get(config.mtfs.path.clientConfig);
  }

  static auth() {
    return authInstance.post(config.mtfs.path.auth);
  }

  static deleteTokens() {
    return authInstance.get(config.mtfs.path.deleteTokens);
  }

  static refreshTokens() {
    return authInstance.get(Request.instance().buildRefreshTokensUrl());
  }
}

export default AuthService;
